import React from "react";

const roles = [
  "BUYER",
  "SUPPLIER",
  "SERVICE PROVIDER",
  "EMPLOYER",
  "PARTNER",
  "ADVERTISER",
  "RESOURCE PROVIDER",
  "OPPORTUNITY CREATOR",
];

export default function OneBusinessRoles() {
  return (
    <section className="dark-band">
      <div className="container">
        <h2>One Business Can Have Many Roles</h2>

        <div className="flow-pills">
          {roles.map((r, i) => (
            <span key={r}>
              {r}
              {i < roles.length - 1 && <span className="mx-2">&rarr;</span>}
            </span>
          ))}
        </div>

        <p className="lead-text">
          A business does not have to remain in one role. A retailer can
          become a wholesaler. A manufacturer can also become a supplier. A
          service provider can also become a customer. A business can
          simultaneously need resources and provide resources.
        </p>

        <div className="pill-statement">
          EVERY BUSINESS IS A RESOURCE FOR OTHER BUSINESS
        </div>
      </div>
    </section>
  );
}
